export enum REACTIONS_LIKES {
    /**
     * @value %NB% likes. Like
     */
    LIKE_BUTTON_ARIA = 'FRONT.CONTENTS.LIKE_BUTTON.ARIA',
}
